module.exports = __webpack_public_path__ + "media/images/projects/14-dashboard-c4d96cc3a0dfd0db3b8d5f7e8e3b056f.jpg";